module.exports = __webpack_public_path__ + "img/ic_16_fitnessplan_change.04cb2a20.svg";